import React from 'react';
import Footer from '../layout/Footer';
import heroImage from '../../img/servicios-corporativos.jpg';

const ServiciosCorporativos = () => {
  return (
    <>
      {/* Hero section with background image */}
      <header
        className="bg-no-repeat bg-cover bg-center relative flex flex-col justify-center py-40 md:py-56"
        style={{
          backgroundImage: `url(${heroImage})`,
          backgroundPosition: 'center 35%'
        }}
      >
        {/* Gradient overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40" />

        {/* Content */}
        <div className="relative z-10 container mx-auto px-8 text-center">
          <h1 className="text-white font-bold text-4xl md:text-6xl mb-4 drop-shadow-2xl">
            Servicios Corporativos
          </h1>
          <p className="text-white text-xl md:text-2xl font-light drop-shadow-xl max-w-3xl mx-auto">
            Soluciones integrales de salud mental para tu empresa
          </p>
        </div>

        {/* Wave decoration at bottom */}
        <div className="text-white relative overflow-hidden">
          <svg viewBox="0 0 640 31" xmlns="http://www.w3.org/2000/svg" className="fill-current relative w-full h-8" style={{ bottom: '-2px' }}>
            <path fill="none" d="M-1-1h802v602H-1z"></path>
            <path d="M640.043 10.243l-35.56-1.725c-35.55-1.665-106.66-5.215-177.77-2.585-71.11 2.535-142.23 11.25-213.34 11.205-71.11.045-142.22-8.67-177.77-12.915-2.37-.285-14.23-1.725-35.56-4.31v30.99h640v-20.66z"></path>
          </svg>
        </div>
      </header>

      {/* Main content */}
      <div className="flex flex-col items-center text-center mx-auto py-12 px-8">
        <div className="max-w-3xl w-full">
          {/* Introduction */}
          <p className="text-lg text-gray-700 mb-10">
            Cuidamos el bienestar emocional de tu equipo con programas diseñados a medida
          </p>

          {/* Services List */}
          <div className="bg-white rounded-lg shadow-lg p-8 mb-10">
            <h2 className="text-2xl font-bold text-higia-cyan mb-6">
              Servicios Ofrecidos
            </h2>
            <ol className="text-left space-y-4 text-lg">
              <li className="flex items-start">
                <span className="font-bold text-higia-bermuda mr-3 text-xl">1.</span>
                <span className="font-semibold">Charlas o talleres grupales</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-higia-bermuda mr-3 text-xl">2.</span>
                <span className="font-semibold">Paquetes de terapias para trabajadores de empresas</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-higia-bermuda mr-3 text-xl">3.</span>
                <span className="font-semibold">Mapeo de necesidades en Salud Mental</span>
              </li>
              <li className="flex items-start">
                <span className="font-bold text-higia-bermuda mr-3 text-xl">4.</span>
                <span className="font-semibold">Otros a solicitud</span>
              </li>
            </ol>
          </div>

          {/* CTA Button */}
          <div className="mb-8">
            <a
              href="https://api.whatsapp.com/send?phone=51922277597&text=Hola! Quiero cotizar servicios corporativos para mi empresa."
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block bg-higia-cyan hover:bg-higia-bermuda text-white font-bold py-4 px-8 rounded-lg text-lg transition-colors duration-300 shadow-md hover:shadow-lg"
            >
              Más información / Quiero cotizar
            </a>
          </div>

          {/* Contact Email */}
          <div className="mt-8">
            <p className="text-gray-700 text-lg">
              También puedes escribirnos a:{' '}
              <a
                href="mailto:hola@higia.pe"
                className="text-higia-bermuda font-semibold hover:underline"
              >
                hola@higia.pe
              </a>
            </p>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default ServiciosCorporativos;
